import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'
import { FiftyFiftyBlock } from 'containers'

class SixtyFourtyBlock extends Component {
  static propTypes = {
    preHeading: PropTypes.string,
    heading: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'disable']),
    blurb: PropTypes.string,
    textAlign: PropTypes.oneOf(['left', 'right', 'center']),
    textVerticalAlign: PropTypes.oneOf(['top', 'bottom', 'center']),
    imageUrl: PropTypes.string.isRequired,
    imagePosition: PropTypes.oneOf(['left', 'right']),
    ImagePositionMobile: PropTypes.bool,
    imageSize: PropTypes.string,
    components: PropTypes.array,
    ratio: PropTypes.number,
    backgroundColor: PropTypes.string
  }
  /**
   * @param {String} [preHeading] - Pre-Heading text.
   * @param {String} [heading] - Heading text.
   * @param {String} [blurb] - blurb text as xhtml string.
   * @param {'left'|'right'|'center'} [textAlign=left] - Text alignment.
   * @param {'top'|'bottom'|'center'} [textVerticalAlign=top] - Vertical text alignment.
   * @param {String} imageUrl - Image url.
   * @param {String} [backgroundColor='#f5f5f5'] - Background color as HTML hex code.
   * @param {'true'|'false'} [imagePositionMobile=false] - true means image should be on top always
   * @param {'left'|'right'} [imagePosition=left] - Image position.
   * @param {Array|Button} [components] - Array of nested components.
   * @returns {ReactElement} React Component
   */
  render() {
    const props = this.props
    return (
      <FiftyFiftyBlock
        {...props}
        imageAlign={props.imagePosition === 'left' ? 'left' : 'right'}
        ratio={props.imagePosition === 'left' ? 60 : 40} />
    )
  }
}

export default Radium(SixtyFourtyBlock)



// WEBPACK FOOTER //
// ./src/containers/sixty-fourty-block/index.jsx